import React, { FC, memo } from "react";

import { ChartWrapperContainer } from "./styled";
import { ChartLoading } from "../Loading/ChartLoading";
import { FILTERED_VALUE_OPACITY } from "../../constants";
import { ChartContainerProps } from "./types";

export const ChartWrapper: FC<ChartContainerProps> = memo(({ width, height, column, loading, children }) => {
  return (
    <ChartWrapperContainer column={column} style={{ width, height }}>
      {loading && <ChartLoading column={column} />}
      <div style={{ opacity: loading ? FILTERED_VALUE_OPACITY / 100 : 1 }}>{children}</div>
    </ChartWrapperContainer>
  );
});
